<template>
  <b-modal :id="id || 'admin_modal_form'" lazy hide-footer centered no-close-on-backdrop :size="config.modal_size || 'lg'">
    <template slot="modal-title">
      <i v-if="id_to_edit" class="far fa-pencil"></i>
      <i v-else class="far fa-plus fa-lg"></i>
      {{ id_to_edit ? "Edition de la fiche" : "Nouvelle fiche" }}
    </template>
    <component :is="config.formComponentName" :id_to_edit="id_to_edit" :params="params"
      @submit:create:success="submitCreateSuccess" @submit:update:success="submitUpdateSuccess"
      @submit:create:error="submitCreateError" @submit:update:error="submitUpdateError" />
  </b-modal>
</template>

<script>
// Tous les formulaires qui peuvent être chargés en modal
import UserForm from "@/components/User/UserForm";
import CompanyForm from "@/components/Company/CompanyForm";
import CompanyContactForm from "@/components/CompanyContact/CompanyContactForm";
import CompanyGroupForm from "@/components/CompanyGroup/CompanyGroupForm";
import ComplaintForm from "@/components/Complaint/ComplaintForm";
import ReferenceForm from "@/components/Reference/ReferenceForm";
import RentingForm from "@/components/Renting/RentingForm";
import BusinessReturnForm from "@/components/BusinessReturn/BusinessReturnForm";
import TransferForm from "@/components/Transfer/TransferForm";
import ShippingForm from "@/components/Shipping/ShippingForm";
import SparePartForm from "@/components/SparePart/SparePartForm";
import StorageEnvironmentForm from "@/components/StorageEnvironment/StorageEnvironmentForm";
import StorageZoneForm from "@/components/StorageZone/StorageZoneForm";
import WarehouseForm from "@/components/Warehouse/WarehouseForm";
import MyaxilocSettingForm from "@/components/MyaxilocSetting/MyaxilocSettingForm";
import AxilocSettingForm from "@/components/AxilocSetting/AxilocSettingForm";
import TransportRateForm from "@/components/TransportRate/TransportRateForm";
import ExternalMaintenanceForm from "@/components/ExternalMaintenance/ExternalMaintenanceForm";
import ManualBillingForm from "@/components/ManualBilling/ManualBillingForm";
import ProductForm from "@/components/Product/ProductForm";
import AgencyForm from "@/components/Agency/AgencyForm";
import AgencyGroupForm from "@/components/AgencyGroup/AgencyGroupForm";
import BusinessForm from "@/components/Business/BusinessForm";
import EmployeeForm from "@/components/Employee/EmployeeForm";
import FaqForm from "@/components/Faq/FaqForm";
import TheTeamForm from "@/components/TheTeam/TheTeamForm";
import BusinessReturnMobileForm from "@/components/BusinessReturnMobile/BusinessReturnMobileForm";
import RequestAttributeForm from "@/components/RequestAttribute/RequestAttributeForm";
import FeeLabelForm from "@/components/FeeLabel/FeeLabelForm";

export default {
  name: "AdminModalForm",
  components: {
    UserForm,
    CompanyForm,
    CompanyContactForm,
    CompanyGroupForm,
    ComplaintForm,
    ReferenceForm,
    RentingForm,
    BusinessReturnForm,
    BusinessReturnMobileForm,
    TransferForm,
    ShippingForm,
    SparePartForm,
    StorageEnvironmentForm,
    StorageZoneForm,
    WarehouseForm,
    MyaxilocSettingForm,
    AxilocSettingForm,
    TransportRateForm,
    ExternalMaintenanceForm,
    ManualBillingForm,
    ProductForm,
    AgencyForm,
    AgencyGroupForm,
    BusinessForm,
    EmployeeForm,
    FaqForm,
    TheTeamForm,
    RequestAttributeForm,
    FeeLabelForm
  },
  props: ["config", "id_to_edit", "params", "id"],
  methods: {
    submitCreateSuccess(response) {
      this.$emit("submit:create:success", response);
    },
    submitUpdateSuccess(response) {
      this.$emit("submit:update:success", response);
    },
    submitCreateError(error) {
      this.$emit("submit:create:error", error);
    },
    submitUpdateError(error) {
      this.$emit("submit:update:error", error);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Global/AdminModalForm.vue